.menu { min-width: 160px; padding: 6px; }
.item {
  display: flex; align-items: center; justify-content: space-between; gap: 12px;
  width: 100%; padding: 8px 10px; border-radius: 6px; text-align: left;
  font-size: 12px; line-height: 16px; color: var(--text-value); white-space: nowrap;
}
.item:hover { background: var(--bg-table-header); }
.item.active { background: var(--bg-row-selected); font-weight: 600; }
.tick { color: #2f6feb; font-size: 12px; }
